/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingRequest } from '../../models/setting-request';
import { StoreSettingResponse } from '../../models/store-setting-response';

export interface StoreSettingPut$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;

/**
 * Setting identifier
 */
  id: 'OM_INJECTION';
      body: SettingRequest
}

export function storeSettingPut(http: HttpClient, rootUrl: string, params: StoreSettingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreSettingResponse>> {
  const rb = new RequestBuilder(rootUrl, storeSettingPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreSettingResponse>;
    })
  );
}

storeSettingPut.PATH = '/stores/{storeId}/settings/{id}';
